import * as React from 'react';

interface Props {
  label: React.ReactNode;
  description?: React.ReactNode;
  onCheck: (checked: boolean) => void;
  checked: boolean;
  className?: string;
  /** It is crucial that this ID is unique for the DOM; otherwise behavior gets very strange and unexpected */
  id: string;
}

export const Checkbox: React.FC<Props> = (props) => {
  const { label, description, onCheck, checked, className } = props;
  const id = `checkbox-${props.id}`;

  const toggle = React.useCallback(() => onCheck(!checked), [checked, onCheck]);

  return (
    <label
      htmlFor={id}
      className={`relative flex items-center space-x-2 cursor-pointer! ${className}`}
    >
      <div className="flex h-full items-center">
        <input
          id={id}
          aria-describedby={description ? `${id}-description` : undefined}
          name={id}
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
          checked={checked}
          onChange={toggle}
        />
      </div>
      <div>
        <div className="font-medium text-gray-900">{label}</div>
        {description && (
          <p id={`${id}-description`} className="text-gray-500">
            {description}
          </p>
        )}
      </div>
    </label>
  );
};
Checkbox.displayName = 'Checkbox';
